module.exports = __webpack_public_path__ + "img/desktop6.18c8610a.gif";